import { Campaign, CampaignUpdateDto } from "../../models/emailcampaign";

export namespace CampaignStateActions {
    export class LoadCampaigns {
        static readonly type = "[Campaign] Load Campaigns";
        constructor() { }
    }

    export class CampaignCreated {
        static readonly type = "[Campaign] Campaign Created";
        constructor(public payload: { campaign: Campaign }) { }
    }

    export class CampaignUpdated {
        static readonly type = "[Campaign] Campaign Updated";
        constructor(public payload: { id: number; updateDto: CampaignUpdateDto }) { }
    }

    export class CampaignDeleted {
        static readonly type = "[Campaign] Campaign Deleted";
        constructor(public payload: { id: number }) { }
    }
}